import React from 'react'
import PropTypes from 'prop-types'
import {Link} from 'gatsby'
import tw from 'twin.macro'

const Card = tw(Link)`hocus:bg-white transition ease-in-out duration-200 border border-gray-200 hocus:shadow rounded p-2 text-center h-full`
const CardTitle = tw.div`font-bold`
const CardDetails = tw.ul``
const CardDetail = tw.li`text-gray-600 text-xs truncate`

const ContactCard = ({title, details, id}) => {
  return (
    <Card to={`/contacts-directory/${id}`}>
      <CardTitle>{title}</CardTitle>
      <CardDetails>
        {details.map((item,i) => <CardDetail key={`detail-${i}`}>{item}</CardDetail>)}
      </CardDetails>
    </Card>
  )
}

ContactCard.propTypes = {
  title: PropTypes.string,
  details: PropTypes.array,
  id: PropTypes.string
}

export default ContactCard
